export default "__VITE_ASSET__Cg095I1M__"